/* src/app/admin/power-bi/power-bi-dashboard/power-bi-dashboard.component.scss */
.powerbi-wrapper {
  padding: 20px;
  background-color: #fff;
}
.powerbi-wrapper .loading-spinner {
  text-align: center;
  padding: 100px;
  font-size: 20px;
  color: #666;
}
/*# sourceMappingURL=power-bi-dashboard.component-SAKLG4PB.css.map */
